import React from 'react';
import { XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Chauffeur } from '../../types';

interface DeleteDriverModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  driver: Chauffeur;
}

const DeleteDriverModal: React.FC<DeleteDriverModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  driver
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            Supprimer le chauffeur
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Contenu */}
        <div className="p-6">
          <div className="flex items-center space-x-3 mb-4">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-500" />
            <h4 className="text-md font-medium text-gray-900">
              Confirmation de suppression
            </h4>
          </div>
          
          <p className="text-gray-600 mb-6">
            Êtes-vous sûr de vouloir supprimer le chauffeur <strong>"{driver.prenom} {driver.nom}"</strong> ?
          </p>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex">
              <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
              <div className="ml-3">
                <h5 className="text-sm font-medium text-yellow-800">
                  Attention
                </h5>
                <p className="text-sm text-yellow-700 mt-1">
                  Cette action est irréversible. Toutes les données associées à ce chauffeur seront supprimées définitivement.
                </p>
              </div>
            </div>
          </div>

          {/* Informations du chauffeur */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h5 className="text-sm font-medium text-gray-900 mb-2">Informations du chauffeur :</h5>
              <div className="text-sm text-gray-600 space-y-1">
               <p><span className="font-medium">Nom :</span> {driver.prenom} {driver.nom}</p>
               <p><span className="font-medium">Permis :</span> {driver.permis}</p>
               <p><span className="font-medium">Téléphone :</span> {driver.telephone || 'Non renseigné'}</p>
               {driver.email && <p><span className="font-medium">Email :</span> {driver.email}</p>}
               <p><span className="font-medium">Livraisons :</span> {driver.nombre_livraisons || 0}</p>
             </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex justify-end space-x-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
          >
            Supprimer définitivement
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDriverModal;
